import { Image } from "antd";
import Link from "antd/lib/typography/Link";
import { priceCrudApi } from "../client/EntityApi";
import {
  getPriceCPColumns,
  getPriceCPFormItems,
} from "../components/crud/PriceCPComponents";
import CrudTable from "../core/component/crud/CrudTable";
import { getFullPath, isImageMedia } from "../core/helper/UtilHelper";

const PriceCrudPage = () => {
  return (
    <CrudTable
      entityLabel="Fiyat"
      api={priceCrudApi}
      searchKeys={["name"]}
      columns={getPriceCPColumns()}
      addFormItems={getPriceCPFormItems()}
      editFormItems={getPriceCPFormItems()}
      expandable={{
        expandedRowRender: (record: any) => (
          <>
            {record.image && isImageMedia(record.image.extension) ? (
              <Image width={200} src={getFullPath(record.image.uid)} />
            ) : (
              <Link target="_blank" href={getFullPath(record.image.uid)}>
                {record.image.name}
              </Link>
            )}
          </>
        ),
      }}
    />
  );
};

export default PriceCrudPage;
